import * as React from "react"
import type { SVGProps } from "react"
const SvgNoteMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    width={24}
    height={24}
    {...props}
  >
    <path d="M3.71 12.29H9.1V9.9a.8.8 0 0 1 .23-.58.8.8 0 0 1 .58-.23h2.39V3.7H3.7zm0 1.63q-.67 0-1.15-.48a1.6 1.6 0 0 1-.48-1.15V3.7q0-.67.48-1.15t1.15-.48h8.58q.67 0 1.15.48t.48 1.15v5.25q0 .33-.12.62-.11.3-.37.55l-3.3 3.3a1.6 1.6 0 0 1-1.17.49zm3.65-4.6H5.58a.65.65 0 0 1-.67-.68q0-.28.2-.47.2-.2.48-.2h1.77q.3 0 .48.2a.6.6 0 0 1 .19.46.7.7 0 0 1-.2.48.6.6 0 0 1-.47.2Zm3.06-2.55H5.58a.6.6 0 0 1-.48-.2.7.7 0 0 1-.19-.47q0-.29.2-.48.2-.18.48-.19h4.83q.29 0 .47.2a.6.6 0 0 1 .2.46.7.7 0 0 1-.2.48.6.6 0 0 1-.47.2" />
  </svg>
)
export default SvgNoteMini
